<template>
  <AppLayout>
    <div data-component="Admin/Layout">

      <!-- Barre de navigation admin -->
      <nav class="admin-nav">
        <div class="admin-nav__inner">
          <div class="admin-nav__title">
            <i class="fas fa-shield-alt"></i>
            <span>Administration</span>
          </div>
          <ul class="admin-nav__links">
            <li v-for="item in navItems" :key="item.to">
              <router-link
                :to="item.to"
                class="admin-nav__link"
                active-class="admin-nav__link--active"
              >
                <i :class="item.icon"></i>
                <span>{{ item.label }}</span>
              </router-link>
            </li>
          </ul>
        </div>
      </nav>

      <!-- Contenu de la page admin courante -->
      <div class="admin-content">
        <router-view />
      </div>

    </div>
  </AppLayout>
</template>

<script>
import AppLayout from '../../components/Layout/AppLayout.vue'

export default {
  name: 'AdminLayout',
  components: {
    AppLayout
  },
  data() {
    return {
      navItems: [
        {
          to: '/admin/mandants',
          icon: 'fas fa-building',
          label: 'Mandants'
        },
        {
          to: '/admin/dernieres-visites',
          icon: 'fas fa-calendar-times',
          label: 'Dates de prochaine visite'
        },
        {
          to: '/admin/database-sync',
          icon: 'fas fa-database',
          label: 'Synchronisation DB'
        },
        {
          to: '/admin/visit-sync-mssql',
          icon: 'fas fa-upload',
          label: 'Sync MySQL → MSSQL'
        },
        {
          to: '/admin/doublons-visites',
          icon: 'fas fa-copy',
          label: 'Doublons visites'
        },
        {
          to: '/admin/import-photos',
          icon: 'fas fa-images',
          label: 'Import photos'
        },
        {
          to: '/admin/sql-query',
          icon: 'fas fa-terminal',
          label: 'SQL Query'
        },
        {
          to: '/admin/api-explorer',
          icon: 'fas fa-plug',
          label: 'API Explorer'
        },
        {
          to: '/admin/techniciens-visites',
          icon: 'fas fa-user-edit',
          label: 'Techniciens visites'
        },
        {
          to: '/admin/doublons-lots',
          icon: 'fas fa-clone',
          label: 'Doublons immeuble+lot'
        },
        {
          to: '/admin/nettoyage-visites',
          icon: 'fas fa-broom',
          label: 'Nettoyage visites'
        },
        {
          to: '/admin/photos-base64',
          icon: 'fas fa-image',
          label: 'Photos base64'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
[data-component="Admin/Layout"] {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 56px); /* hauteur de la barre AppLayout */
}

.admin-nav {
  background-color: #1e293b;
  color: #e2e8f0;
  border-bottom: 2px solid #4f46e5;
  position: sticky;
  top: 56px;
  z-index: 40;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}

.admin-nav__inner {
  width: 100%;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.admin-nav__title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #818cf8;
  white-space: nowrap;
  padding: 0.75rem 0;
  border-right: 1px solid #334155;
  padding-right: 1.5rem;
  flex-shrink: 0;

  i {
    font-size: 0.85rem;
  }
}

.admin-nav__links {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 0.25rem;
  flex-wrap: nowrap;
}

.admin-nav__link {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.6rem 0.85rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: #94a3b8;
  text-decoration: none;
  border-radius: 6px;
  border: 1px solid transparent;
  white-space: nowrap;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s;

  i {
    font-size: 0.8rem;
    opacity: 0.75;
  }

  &:hover {
    color: #e2e8f0;
    background-color: #334155;
  }

  &--active {
    color: #fff;
    background-color: #4f46e5;
    border-color: #6366f1;

    i {
      opacity: 1;
    }

    &:hover {
      background-color: #4338ca;
    }
  }
}

.admin-content {
  flex: 1;
  overflow-y: auto;

  /* Les vues admin ont leur propre fond gris — on neutralise le double-fond */
  background-color: #f9fafb;
}
</style>
